/**
 * Run callback on success and fail action
 * Put your callback in the meta props of the action object
 * Action object: { type: '...', meta : { onSuccess: () => {}, onFailure: () => {} }}
 */
const callbackMiddleware = () => next => action => {
  try {
    const res = next(action);
    const { type, meta = {}, payload } = action;
    const { onSuccess, onFailure } = meta;
    if (type && type.includes('SUCCESS') && onSuccess) onSuccess(payload);
    else if (type && type.includes('FAILURE') && onFailure) onFailure(payload);
    return res;
  } catch (error) {
    console.error('Caught an exception!', error);
    throw error;
  }
};

export default callbackMiddleware;
